import { defineStore } from 'pinia'

export const useErrorsStore = defineStore('errors-store', {
  state: () => ({
    errors: []
  }),
  actions: {
    addErrorAction({
      errorSourceStore,
      errorSourceAction,
      errorSourceArgs,
      errorName,
      errorMessage
    }) {
      this.errors.push({
        errorSourceStore,
        errorSourceAction,
        errorSourceArgs,
        errorName,
        errorMessage
      })
    },
    removeErrorAction({
      errorSourceStore,
      errorSourceAction,
      errorSourceArgs,
      errorName,
      errorMessage
    }) {
      this.errors = this.errors.filter((error) => {
        return (
          error.errorSourceStore !== errorSourceStore &&
          error.errorSourceAction !== errorSourceAction &&
          error.errorName !== errorName &&
          error.errorMessage !== errorMessage
        )
      })
    }
  }
})
